module.exports = __webpack_public_path__ + "static/media/16UNODC23.dc09d373.jpg";